<div class="items-in-trash-container">
    <tree-root [nodes]="nodes()" (moveNode)="moveNode($event)"
        [options]="options()" [focused]="true">
        <ng-template #treeNodeTemplate let-node>
            <app-item [node]="node" (expandItemDetails)="expandItemDetails($event)" [isExpanded]="collapseExpandedItem(node)" [isHistoryExpanded]="collapseExpandedItemHistory(node)"></app-item>
        </ng-template>
        <ng-template #loadingTemplate></ng-template>
    </tree-root>
</div>